module.exports = __webpack_public_path__ + "img/minimize-icon.a6b05f24.svg";